import { Box } from '@mui/material';

import { ReportWidgetChart } from '../ReportWidgetChart';
import { ReportWidgetTable } from '../ReportWidgetTable';

import type { ComposableWidgetLayoutProps } from '../../model/types';

export const ComposableWidgetSideBySide = ({
    chartItems,
    visibleItems,
    visualization,
    table,
    modelLabel,
    loading,
    isPrinting,
    disableChartAnimation,
    isInitialLoading,
    isLoadingMore,
    hasMore,
    handleLoadMore,
    loadMoreCount,
    canCollapse,
    handleCollapse,
    itemColors,
    rowClickHandler,
    detailsClickHandler,
    chartItemClickHandler,
    hoveredItemId,
    tableActiveItemId,
    chartHoverHandler,
    tableRowHoverHandler,
    loadMoreHoverHandler,
}: ComposableWidgetLayoutProps): JSX.Element => {
    const shouldStackForPrint = isPrinting;

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: shouldStackForPrint ? 'column' : 'row',
                gap: shouldStackForPrint ? '16px' : '24px',
                alignItems: 'stretch',
                minWidth: 0,
                width: '100%',
                overflow: 'visible',
            }}
        >
            <Box
                sx={{
                    width: shouldStackForPrint ? '100%' : '280px',
                    minWidth: shouldStackForPrint ? 0 : '280px',
                    maxWidth: shouldStackForPrint ? '100%' : '280px',
                    flex: shouldStackForPrint ? '1 1 auto' : '0 0 280px',
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <ReportWidgetChart
                    items={chartItems}
                    chartType={visualization.type}
                    options={visualization.options}
                    modelLabel={modelLabel}
                    loading={loading}
                    isPrinting={isPrinting}
                    disableAnimation={disableChartAnimation}
                    makeSticky={!shouldStackForPrint}
                    onItemClick={chartItemClickHandler}
                    activeItemId={hoveredItemId ?? undefined}
                    onItemHover={chartHoverHandler}
                />
            </Box>
            <Box
                sx={{
                    flex: 1,
                    width: shouldStackForPrint ? '100%' : 0,
                    minWidth: 0,
                }}
            >
                <ReportWidgetTable
                    items={visibleItems}
                    columns={table.columns}
                    modelLabel={modelLabel}
                    loading={isInitialLoading}
                    isPrinting={isPrinting}
                    loadingMore={isLoadingMore}
                    hasMore={hasMore}
                    onLoadMore={handleLoadMore}
                    canCollapse={canCollapse}
                    onCollapse={handleCollapse}
                    itemColors={itemColors}
                    options={{
                        ...table.options,
                        loadMoreCount,
                    }}
                    onRowClick={rowClickHandler}
                    onDetailsClick={detailsClickHandler}
                    activeItemId={tableActiveItemId}
                    onRowHover={tableRowHoverHandler}
                    onLoadMoreHover={loadMoreHoverHandler}
                />
            </Box>
        </Box>
    );
};
